var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 5v13.333m0-13.334H7.052c-.434 0-.85-.175-1.158-.488a1.68 1.68 0 0 1-.479-1.178c0-.442.172-.866.48-1.179a1.62 1.62 0 0 1 1.157-.488c2.292 0 2.946 3.333 2.946 3.333m0 0h2.946c.434 0 .85-.175 1.157-.488.307-.312.48-.736.48-1.178s-.173-.866-.48-1.179a1.62 1.62 0 0 0-1.157-.488c-2.292 0-2.947 3.333-2.947 3.333m6.666 4.167v6.5c0 .933 0 1.4-.182 1.757-.16.313-.414.568-.728.728-.357.182-.823.182-1.757.182H6c-.933 0-1.4 0-1.756-.182a1.67 1.67 0 0 1-.729-.728c-.181-.357-.181-.824-.181-1.757v-6.5M1.666 6.333v1.5c0 .466 0 .7.09.878.08.157.208.284.365.364.178.091.412.091.878.091h14c.467 0 .7 0 .879-.09a.83.83 0 0 0 .364-.365c.09-.178.09-.412.09-.878v-1.5c0-.467 0-.7-.09-.879a.83.83 0 0 0-.364-.364C17.699 5 17.466 5 16.999 5H3c-.466 0-.7 0-.878.09a.83.83 0 0 0-.364.364c-.091.179-.091.412-.091.879"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGift;